"use client";

import { c as _c } from "react/compiler-runtime";
import { ErrorPage } from "@local/ui/src/components/ErrorPage";

/**
 * `global-error.tsx` replaces the entire document when the root layout itself
 * fails, so it has to supply its own `<html>` and `<body>` — the root layout's
 * are gone by the time this renders.
 */
export default function GlobalError(t0) {
  const $ = _c(3);
  const {
    error,
    retry
  } = t0;
  let t1;
  if ($[0] !== error || $[1] !== retry) {
    t1 = <html lang="en"><body><ErrorPage error={error} retry={retry} /></body></html>;
    $[0] = error;
    $[1] = retry;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}